import { GenericalRecord } from '../../../types/utilities'

/**
 * 统一强转结果为 string
 */
export const getKey = (item: GenericalRecord, key: string) => {
  return item[key] as string
}
